import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import OpenNewIcon from '@bufferapp/ui/Icon/Icons/OpenNew'

import { getImgResizeUrl } from '~/shared/utils/urls'

import { Wrapper, Image, Overlay } from './styles'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'src' implicitly has an 'any' type... Remove this comment to see the full error message
const PostThumbnail = ({ src, alt, postURL, service, selected, onError }) => {
  const [imgRefreshed, setImgRefreshed] = useState(false)
  const [placeholder, setPlaceholder] = useState(!src)

  useEffect(() => {
    setPlaceholder(!src)
  }, [src])

  const onImageError = () => {
    setPlaceholder(true)

    if (!imgRefreshed) {
      onError && onError()
      setImgRefreshed(true)
    }
  }

  return (
    <Wrapper
      href={postURL}
      target="_blank"
      rel="noopener noreferrer"
      draggable="false"
      data-testid="post-thumbnail"
      onDragStart={(e) => e.preventDefault()}
    >
      {!placeholder && (
        <Image
          // @ts-expect-error TS(2769) FIXME: No overload matches this call.
          src={getImgResizeUrl(src, 300)}
          alt={alt}
          selected={selected}
          draggable="false"
          onError={onImageError}
          onDragStart={(e) => e.preventDefault()}
        />
      )}
      {postURL && (
        <Overlay>
          <OpenNewIcon size="medium" />
        </Overlay>
      )}
    </Wrapper>
  )
}

PostThumbnail.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  postURL: PropTypes.string,
  service: PropTypes.string,
  selected: PropTypes.bool,
  onError: PropTypes.func,
}

PostThumbnail.defaultProps = {
  src: '',
  alt: '',
  postURL: null,
  service: 'instagram',
  selected: false,
  onError: null,
}

export default PostThumbnail
